export enum UserRole {
  Admin = 'Admin',
  Advanced = 'Advanced',
  Basic = 'Basic',
}

export interface UserSummary {
  id: number;
  provider: string;
  email: string;
  displayName: string;
  isActive: boolean;
  roles: string[];
}

export interface InviteUserRequest {
  email: string;
  displayName?: string;
  roles?: string[];
}

export interface UpdateUserRolesRequest {
  roles: string[];
}

export interface UpdateUserActiveRequest {
  isActive: boolean;
}
